import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { merge } from 'ts-deepmerge';
import { useController } from '@/hooks/useController';
import { useTheme } from '@/hooks/useTheme';
import { languageSelector, initialUserConfig, userConfigState, } from '@/state/config';
import { injectScript } from '../../util/userway';
import { AppContainer } from '../AppContainer/AppContainer';
export const App = ({ userConfig }) => {
    const { notifyWidgetLoaded, notifyUserWayInit } = useController();
    const setUserConfig = useSetRecoilState(userConfigState);
    const language = useRecoilValue(languageSelector);
    const setinitialUserConfig = useSetRecoilState(initialUserConfig);
    const { notifyWidgetResize } = useController();
    useTheme();
    const { i18n } = useTranslation();
    const { enableAccessibilityWidget } = userConfig;
    useEffect(() => {
        if (enableAccessibilityWidget) {
            injectScript();
        }
    }, [enableAccessibilityWidget]);
    useEffect(() => {
        setinitialUserConfig(userConfig);
    }, [setinitialUserConfig, userConfig]);
    // Save the user config
    useEffect(() => {
        if (userConfig) {
            setUserConfig((prev) => merge({}, prev, userConfig));
        }
    }, [setUserConfig, userConfig]);
    // Change language
    useEffect(() => {
        if (i18n === null || i18n === void 0 ? void 0 : i18n.changeLanguage) {
            i18n.changeLanguage(language);
        }
    }, [i18n, language]);
    useEffect(() => {
        document.addEventListener('userway:init_completed', notifyUserWayInit);
        return () => {
            document.removeEventListener('userway:init_completed', notifyUserWayInit);
        };
    }, [notifyUserWayInit]);
    useEffect(() => {
        // Publish an event to announce the widget was configured and rendered
        notifyWidgetLoaded();
    }, [notifyWidgetLoaded]);
    useEffect(() => {
        // Publish an event to announce the widget was configured and rendered
        if (userConfig.widget_alignment === 'left') {
            notifyWidgetResize({
                [userConfig.widget_alignment]: '0px',
            });
        }
    }, [notifyWidgetResize, userConfig]);
    return _jsx(AppContainer, {});
};
